// Services
import callAPI from "../callApi";
import path from "../variables";

const Settings = {
	get: async (filter: any) =>
		await callAPI(
			"GET",
			`${path.base}/agency/settings${filter ? filter : ""}`,
			"",
			"getting specific Settings"
		),
	getTimezones: async (filter: any) =>
		await callAPI("GET", `${path.base}/settings/timezones`, "", "getting timezones for Settings"),
	addOrUpdate: async (params: any, data: any) =>
		await callAPI(
			"PUT",
			`${path.base}/agency/settings${params ? params : ""}`,
			data,
			"adding or updating specific Settings"
		),
	addOrUpdateDailySettings: async (ID: any, data: any) =>
		await callAPI(
			"POST",
			`${path.base}/agency/add-daily-settings${ID ? ID : ""}`,
			data,
			"adding or updating Daily Settings"
		),
	setTimezones: async (data: any) =>
		await callAPI("PUT", `${path.base}/user/timezone`, data, "adding or updating User Timezone"),
};

export default Settings;
